import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const updatePassword = createAsyncThunk(
    'changePasswordForm/updatePassword',
    async ({username, currentPassword, newPassword, token}) => {
        const requestBody = JSON.stringify([currentPassword, newPassword])
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user/users/${username}/updatePassword`,
            {
                method: 'PUT',
                headers: { 
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}` 
                },
                body: requestBody
            }
        )
        .then(response => {
            if (response.ok) {
                return response.text();
            } else {
                throw new Error(response.text());
            }
        })
        return response;
    }
)

export const changePasswordFormSlice = createSlice({
    name: 'changePasswordForm',
    initialState: {
        confirmingChangePassword: false,
        updatingPassword: false,
        failedToUpdatePassword: false,
        newPasswordsMatch: true,
        updatePasswordResult: "",
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: ""
    },
    reducers: {
        changeCurrentPassword: (state, action) => {
            return {
                ...state,
                currentPassword: action.payload
            }
        },
        changeNewPassword: (state, action) => {
            return {
                ...state,
                newPassword: action.payload
            }
        },
        changeConfirmNewPassword: (state, action) => {
            return {
                ...state,
                confirmNewPassword: action.payload
            }
        },
        changeNewPasswordsMatch: (state, action) => {
            return {
                ...state,
                newPasswordsMatch: action.payload
            }
        },
        clearChangePasswordForm: (state) => {
            return {
                ...state,
                currentPassword: "",
                newPassword: "",
                confirmNewPassword: "",
                updatePasswordResult: ""
            }
        },
        changeConfirmingChangePassword: (state, action) => {
            return {
                ...state,
                confirmingChangePassword: action.payload
            }
        }
    },
    extraReducers: {
        [updatePassword.pending]: (state) => {
            return {
                ...state,
                updatingPassword: true,
                failedToUpdatePassword: false
            }
        },
        [updatePassword.fulfilled]: (state, action) => {
            return {
                ...state,
                updatingPassword: false,
                failedToUpdatePassword: false,
                updatePasswordResult: action.payload
            }
        },
        [updatePassword.rejected]: (state) => {
            return {
                ...state,
                updatingPassword: false,
                failedToUpdatePassword: true
            }
        }
    }
})

export const checkNewPasswordsMatch = (state) => state.changePasswordForm.newPasswordsMatch;
export const selectCurrentPassword = (state) => state.changePasswordForm.currentPassword;
export const selectNewPassword = (state) => state.changePasswordForm.newPassword;
export const selectConfirmNewPassword = (state) => state.changePasswordForm.confirmNewPassword;
export const passwordUpdating = (state) => state.changePasswordForm.updatingPassword;
export const checkFailedToUpdatePassword = (state) => state.changePasswordForm.failedToUpdatePassword;
export const selectUpdatePasswordResult = (state) => state.changePasswordForm.updatePasswordResult;
export const selectConfirmingPasswordUpdate = (state) => state.changePasswordForm.confirmingChangePassword;

export const { changeCurrentPassword, changeNewPassword, changeConfirmNewPassword, changeNewPasswordsMatch, clearChangePasswordForm, changeConfirmingChangePassword } = changePasswordFormSlice.actions;

export default changePasswordFormSlice.reducer;